import React from 'react';
import _ from 'lodash';
import {Header, Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const MagentoHeader = ({model}) => (
    <div>
        <Header as='h2'>
            <Icon name='settings' />
            <Header.Content>
                {model.key_2}
                <Header.Subheader>API Access Token: {model.key_1}</Header.Subheader>
                <Header.Subheader>Import: {model.key_4}</Header.Subheader>
                <Header.Subheader>Last Synchronize: {_.isObject(model.synchronize) ? model.synchronize.updated_at : null}</Header.Subheader>
            </Header.Content>
        </Header>
    </div>
)

MagentoHeader.propTypes = {
    model: PropTypes.object.isRequired
};


export default MagentoHeader